import { useGetActorQuery } from '@/app/services/nucleus';

/**
 * Resolves the user or candidate behind one of their ids.
 *
 * `currentData` is scoped to the reference being asked about, so a caller handed a new
 * reference reports loading rather than the actor it resolved for the previous one.
 *
 * @param {{kind?: string, systemName?: string, systemId?: string}} actorRef
 * @param {{skip?: boolean}} [options] - `skip` holds the request back until a caller asks for it.
 * @returns {{actor: object|undefined, isLoading: boolean}}
 */
export const useResolvedActor = ({ kind, systemName, systemId } = {}, { skip = false } = {}) => {
  const { currentData: actor, isFetching } = useGetActorQuery({ kind, systemName, systemId }, { skip: skip || !kind || !systemName || !systemId });

  return { actor, isLoading: isFetching && !actor };
};
